module.exports = __webpack_public_path__ + "img/freezing_rain_light.4827759b.svg";